import FeatureGates from '@atlaskit/feature-gate-js-client';

import { ATLENZ_FF } from 'src/constants';

const MULTIPLE_PRODUCTS_LABEL = 'Multiple products';
const DEFAULT_PRODUCT = 'atlassian';
const supportedProductsList = [
  'atlas',
  'atlassian',
  'bamboo',
  'bitbucket',
  'clover',
  'compass',
  'confluence',
  'crowd',
  'crucible',
  'fisheye',
  'focus',
  'guard',
  'jira',
  'jiraAlign',
  'jiraProductDiscovery',
  'jiraServiceManagement',
  'loom',
  'opsgenie',
  'rovo',
  'sourcetree',
];

export const getContentProduct = (product: string[] | null, supportMultipleProducts: boolean = false): string => {
  if (supportMultipleProducts && product && product.length > 1) {
    return MULTIPLE_PRODUCTS_LABEL;
  }

  const isAtlenzAvailable = FeatureGates.checkGate(ATLENZ_FF);

  const toCamelCase = (str: string): string =>
    str
      .toLowerCase()
      .split(isAtlenzAvailable ? '-' : ' ')
      .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
      .join('');

  if (product && product.length === 1) {
    let currentProduct = toCamelCase(product[0]);

    if (currentProduct === 'jiraCore') {
      currentProduct = 'jira';
    }

    if (currentProduct === 'atlassianGuard') {
      currentProduct = 'guard';
    }

    const productSupported = supportedProductsList.includes(currentProduct);

    return productSupported ? currentProduct : DEFAULT_PRODUCT;
  }

  return DEFAULT_PRODUCT;
};
